import type { EventResourceFormValues } from "./types";

export const EVENT_RESOURCE_FORM_DEFAULTS: EventResourceFormValues = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  country: "",
  company: "",
  website: "",
  jobtitle: "",
  linkedin__c: "",
};

export const eventResourceFieldConfig = {
  firstname: {
    name: "firstname" as const,
    required: true,
  },
  lastname: {
    name: "lastname" as const,
    required: true,
  },
  email: {
    name: "email" as const,
    required: true,
  },
  phone: {
    name: "phone" as const,
    required: true,
  },
  country: {
    name: "country" as const,
    required: true,
  },
  company: {
    name: "company" as const,
    required: true,
  },
  website: {
    name: "website" as const,
    required: true,
  },
  jobtitle: {
    name: "jobtitle" as const,
    required: true,
  },
  linkedin__c: {
    name: "linkedin__c" as const,
    required: false,
  },
};
